import { FC, useEffect } from 'react';
import { motion, useCycle } from 'framer-motion';

import {
  backgroundStyle,
  containerStyle,
  toggleStyle
} from '@/components/common/Toggle/styles.ts';

type SwitchToggleProps = {
  isChecked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  onClick?: () => boolean | void;
};

const Toggle: FC<SwitchToggleProps> = ({
  isChecked = false,
  onChange = () => {},
  onClick,
  disabled
}) => {
  const [current, cycle] = useCycle('off', 'on');

  useEffect(() => {
    cycle(isChecked ? 1 : 0);
  }, [isChecked]);

  const handleToggle = () => {
    if (disabled) return;

    if (onClick) {
      const shouldProceed = onClick();
      if (shouldProceed === false) return;
    }

    cycle();
    onChange(current === 'off');
  };

  return (
    <div
      style={{ ...containerStyle, opacity: disabled ? 0.5 : 1 }}
      onClick={handleToggle}
    >
      <motion.div
        style={backgroundStyle}
        variants={{ off: { scale: 0 }, on: { scale: 1 } }}
        animate={current}
        initial={false}
        transition={{ ease: 'easeInOut' }}
      />
      <motion.div
        style={toggleStyle}
        variants={{ off: { x: 0 }, on: { x: 20 } }}
        animate={current}
        initial={false}
        transition={{ ease: 'easeInOut' }}
      />
    </div>
  );
};

export default Toggle;
